<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <div class="page_label mt-3 p-3">
    <div [formGroup]="getControl('data')">
      <p>
        Tell us about the nursing facility completing the 2350 Form. You can use
        the 2350 to transfer nursing facilities or HCBS.
      </p>
      <p>
        But if you need to request a level of care transition (such as from a
        nursing facility to HCBS), you must call the patient’s health plan. You
        cannot use the 2350 Form to request a level of care transition.
      </p>
      <br />
      <div class="admit-discharge-header">
        <span>Nursing Facility Address</span>
      </div>
      <br />

      <div>
        <nh-field
          id="fain_nursingFacilitySearch"
          label="Search for a Nursing Facility"
          [mandatory]="false"
          [attr.aria-required]="false"
          class="label-section"
        >
          <input
            type="text"
            name="nursingFacilitySearch"
            maxlength="100"
            class="form-control"
            aria-label="nursingFacilitySearch"
            formControlName="nursingFacilitySearch"
          />
        </nh-field>
      </div>

      <div class="row g-3 justify-content-start">
        <div class="col-5 col-md-2 py-2 py-md-0 order-md-2">
          <button class="btn btn-block btn-secondary" (click)="onSearch()">
            Search&nbsp; <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <br />
      @if ((rows | async) || showTable) {
      <ngx-datatable
        class="bootstrap striped"
        #table
        [rows]="result"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [limit]="limit"
        [selected]="selected"
        [selectionType]="'single'"
        (select)="onSelect($event)"
        [messages]="{ emptyMessage: 'No results for your search' }"
      >
        <ngx-datatable-column
          name="Institution ID"
          prop="InstitutionID"
        ></ngx-datatable-column>
        <ngx-datatable-column
          name="Institution Name"
          prop="InstitutionName"
        ></ngx-datatable-column>
        <ngx-datatable-column name="Address">
          <ng-template ngx-datatable-cell-template let-row="row">
            <span [attr.aria-label]="row.address">{{ row.address }}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Select">
          <ng-template
            id="fain_select"
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
            let-value="value"
            let-isSelected="isSelected"
            let-onCheckboxChangeFn="onCheckboxChangeFn"
          >
            <input
              type="checkbox"
              name="select"
              formControlName="select"
              [checked]="isSelected"
              (change)="onCheckboxChangeFn($event)"
            />
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      }
      <br />
      @if (noResults) {
      <div>
        <p class="mt-3">No results for your search</p>
      </div>
      }
      <div
        class="col-12 col-sm-12 col-md-8 col-lg-6 py-2 py-md-0 order-md-1 nursing-btn-styles"
      >
        <button
          type="button"
          class="btn btn-block btn-secondary"
          (click)="onClick()"
        >
          I can't find my nursing facility
          <img
            src="../../../../../assets/images/close-icon.svg"
            alt=""
            aria-hidden="true"
          />
        </button>
        <br />
      </div>
      <br />

      @if (showNursingDetails) {
      <div>
        <nh-field
          id="fain_nursingFacilityName"
          label="Name of Nursing Facility"
          class="label-section"
          [mandatory]="!isNursingRowSelected"
          [attr.aria-required]="!isNursingRowSelected"
        >
          <input
            type="text"
            name="nursingFacilityName"
            class="form-control"
            formControlName="nursingFacilityName"
            [attr.disabled]="disableAddress ? true : null"
            aria-label="Name of Nursing Facility"
          />
        </nh-field>
        <div [formGroup]="getControl('data.nursingFacilityAddress')">
          <nh-name-address
            [addressname]="'hh_nursingFacilityAddress'"
            [addressname]="'fain'"
            [address]="getControl('data.nursingFacilityAddress.address')"
            [isAssistingPerson]="true"
            [tables]="tables"
            [showPopup]="false"
            [isDisabled]="disableAddress"
            [addressFieldMandatory]="!isNursingRowSelected"
          ></nh-name-address>
        </div>
      </div>
      }

      <div [formGroup]="getControl('data.admissionInfo')">
        @if (admitDischarge === 'Admission') {
        <div>
          <div class="admit-discharge-header">
            <span>Admission Information</span>
          </div>
          <br />
          <nh-field
            id="fain_admissionDt"
            label="Admission Date"
            [mandatory]="admissionDate"
            [attr.aria-required]="admissionDate"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="admissionDt"
                class="form-control"
                formControlName="admissionDt"
                aria-label="admissionDate"
                [attr.aria-required]="true"
                [minDate]="minDate"
                [maxDate]="today"
                bsDatepicker
                nh
              />
            </nh-datepicker>
          </nh-field>
          <nh-field
            id="fain_prevConfStartDt"
            label="Previous Confinement Start Date"
            [mandatory]="false"
            [attr.aria-required]="false"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="prevConfStartDt"
                class="form-control"
                formControlName="prevConfStartDt"
                aria-label="previous Confinement Start Date"
                [minDate]="minDate"
                [maxDate]="today"
                bsDatepicker
                nh
              />
            </nh-datepicker>
          </nh-field>
          <nh-field
            id="fain_prevConfEndDt"
            label="Previous Confinement End Date"
            [mandatory]="false"
            [attr.aria-required]="false"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="prevConfEndDt"
                class="form-control"
                formControlName="prevConfEndDt"
                aria-label="Previous Confinement End Date"
                [minDate]="minDate"
                [maxDate]="today"
                bsDatepicker
                nh
              />
            </nh-datepicker>
          </nh-field>
          <nh-field
            id="fain_hospiceSw"
            label="Is the patient receiving hospice care in this nursing facility?"
            [mandatory]="false"
            [attr.aria-required]="false"
            class="label-section"
          >
            <select
              nh
              name="hospiceSw"
              [items]="tables.YESNO"
              formControlName="hospiceSw"
              aria-label="Is the patient receiving hospice care in this nursing facility?"
            ></select>
          </nh-field>
          <nh-field
            id="fain_stateVeteranSw"
            label="Is this nursing facility a state veterans home?"
            [mandatory]="false"
            [attr.aria-required]="false"
            class="label-section"
          >
            <select
              nh
              name="stateVeteranSw"
              [items]="tables.YESNO"
              formControlName="stateVeteranSw"
              aria-label="Is this nursing facility a state veterans home?"
            ></select>
          </nh-field>
        </div>
        }
      </div>
      <br /><br />
      <div [formGroup]="getControl('data.dischargeInfo')">
        @if (admitDischarge === 'Discharge') {
        <div>
          <div class="admit-discharge-header">
            <span>Discharge Information</span>
          </div>
          <br />
          <nh-field
            id="fain_dischargereason"
            label="Reason for Discharge"
            [mandatory]="true"
            [attr.aria-required]="true"
            class="label-section"
          >
            <select
              nh
              name="dischargereason"
              [items]="tables.DISCHRSN"
              formControlName="dischargereason"
              aria-label="Reason for Discharge"
            ></select>
          </nh-field>
          @if (showDischargeDate) {
          <nh-field
            id="fain_dischargeDt"
            label="Discharge Date"
            [mandatory]="true"
            [attr.aria-required]="true"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="dischargeDt"
                class="form-control"
                formControlName="dischargeDt"
                [minDate]="minDate"
                [maxDate]="today"
                [attr.aria-label]="'dischargeDate' | translate"
                bsDatepicker
                nh
              />
            </nh-datepicker>
          </nh-field>
          } @if (showDeathDate) {
          <nh-field
            id="fain_dateOfDeath"
            label="Date of Death"
            [mandatory]="true"
            [attr.aria-required]="true"
            class="label-section"
          >
            <nh-datepicker>
              <input
                type="text"
                name="dateOfDeath"
                class="form-control"
                formControlName="dateOfDeath"
                [minDate]="minDate"
                [maxDate]="today"
                aria-label="Date Of Death"
                bsDatepicker
                nh
              />
            </nh-datepicker>
          </nh-field>
          } @if (showDischargeDate) {
          <nh-field
            id="fain_dischargeAddrSw"
            label="Do you have a new address to report for this person?"
            [mandatory]="true"
            [attr.aria-required]="true"
            class="label-section"
          >
            <select
              nh
              name="dischargeAddrSw"
              [items]="tables.YESNO"
              formControlName="dischargeAddrSw"
              aria-label="Do you have a new address to report for this person?"
            ></select>
          </nh-field>
          } @if (showDischargeDate && showNewAddress) {
          <div>
            <div
              [formGroup]="getControl('data.dischargeInfo.dischargeAddress')"
            >
              <nh-name-address
                [addressname]="'hh_dischargeAddress'"
                [address]="
                  getControl('data.dischargeInfo.dischargeAddress.address')
                "
                [isAssistingPerson]="true"
                [tables]="tables"
                [showPopup]="false"
              ></nh-name-address>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</nh-form>
